import { useContext, useState } from 'react'
import Text from './Text'
import ErrorMessage from './Error'
import Button from './Button'
import Padded from './Padded'
import Content from './Content'
import FlexCol from './FlexCol'
import CenterScreen from './CenterScreen'
import { consoleError } from '../lib/logs'
import InputPassword from './InputPassword'
import ButtonsOnBottom from './ButtonsOnBottom'
import { WalletContext } from '../providers/wallet'
import { authenticateUser } from '../lib/biometrics'
import LockIcon from '../icons/Lock'
import { useTranslation } from '../providers/language'

interface NeedsPasswordProps {
  error: string
  onPassword: (password: string) => void | Promise<void>
}

export default function NeedsPassword({ error, onPassword }: NeedsPasswordProps) {
  const { wallet } = useContext(WalletContext)
  const { t } = useTranslation()
  const [password, setPassword] = useState('')

  const handleBiometrics = () => authenticateUser(wallet.passkeyId).then(onPassword).catch(consoleError)
  const handleChange = (ev: any) => setPassword(ev.target.value)
  const handleClick = () => onPassword(password)

  return (
    <>
      <Content>
        <Padded>
          {wallet.lockedByBiometrics ? (
            <CenterScreen onClick={handleBiometrics}>
              <LockIcon big />
              <Text centered>{t('unlock.unlockWithPasskey')}</Text>
            </CenterScreen>
          ) : (
            <FlexCol gap='1rem' testId='password'>
              <InputPassword
                focus
                label={t('unlock.insertPassword')}
                onChange={handleChange}
                onEnter={handleClick}
                placeholder={t('unlock.passwordPlaceholder')}
              />
              <ErrorMessage text={error} error={Boolean(error)} />
            </FlexCol>
          )}
        </Padded>
      </Content>
      <ButtonsOnBottom>
        <Button onClick={wallet.lockedByBiometrics ? handleBiometrics : handleClick} label={t('unlock.unlockWallet')} />
      </ButtonsOnBottom>
    </>
  )
}
